module.exports = __webpack_public_path__ + "img/9.b5dd6b01.png";